import React, { useEffect, useRef, useState } from "react";
import { Autocomplete, CircularProgress, TextField, Tooltip } from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import LogoutIcon from "@mui/icons-material/Logout";
import DeleteIcon from "@mui/icons-material/Delete";
import { callAPI } from "../../../axios";
import { ScrollToTop, getUserRoleCodeFromStorage } from "../../../utils/utils";
import TableWrapper from "../../core/BaseComponents/TableWrapper/TableWrapper";
import { MdModeEditOutline } from "react-icons/md";
import BasicModal from "../../core/BaseComponents/Modal";
import deleteImg from '../../../assets/images/delete.png';
import { IoMdWarning } from "react-icons/io";
import dayjs from "dayjs";
// import ImageResolutionTooltip from "../ConfigurationNewHotel/ImageResolutionTooltip";

export default function PMSHelpManual(props) {

    let userRoleCode = getUserRoleCodeFromStorage();
    const [uploadApkList, setUploadApkList] = useState([]);
    const [editHotel, setEditHotel] = useState(false);
    const [editHotelSid, setEditHotelSid] = useState("");
    const [editHotelUpdate, setEditHotelUpdate] = useState(false);
    const [deleteHotelPopUp, setDeleteHotelPopUp] = useState(false);
    const [createHotelSuccessMsg, setCreateHotelSuccessMsg] = useState('');
    const [confirmDeleteHotel, setConfirmDeleteHotel] = useState("");
    const [confirmValidate, setConfirmValidate] = useState(false);
    const [loader, setLoader] = useState(false)

    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
        watch,
        control
    } = useForm({
        mode: 'onChange',
    });

    let validPermissionClassName = userRoleCode === "ROLE_SUPER_ADMIN"
    ? ""
    : "btn-disable-permission";

    const manualType = ["EVERYONE","IHCL","TP-HMS"];

    const helperCategory = (value) =>{
        if(value==="EVERYONE") return "all"
        else if (value==="IHCL") return "ihcl"
        else if (value==="TP-HMS") return "hms"
    }

    const helperCategoryTable = (value) =>{
        if(value==="all") return "EVERYONE"
        else if (value==="ihcl") return "IHCL"
        else if (value==="hms") return "TP-HMS"
    }

    const onSubmit = (data) => {
        const formData = new FormData();
        if (data.file[0]) {
            formData.append('file', data.file[0]);
        }
        let method = "POST";
        let url = `/documents?displayName=${data?.displayName}&category=${helperCategory(data?.category)}`;
        if (editHotelUpdate) {
            method = "PUT";
            url = `/documents/${editHotelSid?.id}?displayName=${data?.displayName}&category=${helperCategory(data?.category)}`;
        }
        setLoader(true);
        callAPI(url, method, formData )
            .then(function (response) {
                setCreateHotelSuccessMsg(response?.message);
                reset({
                    displayName: '',
                    category: '',
                    file: [{name:"" , url:""}],
                });
                uploadApkListApi();
                setEditHotelSid('');
                setEditHotel(false);
                setLoader(false);
            })
            .catch(function (error) {
                console.warn(error.response?.data?.errorMessage);
                setLoader(false);
            });
    };

    const renderAPKActionIcon = (row) => {
        return (
            userRoleCode === "ROLE_SUPER_ADMIN"?<>
                <Tooltip title="Edit" arrow>
                    <span><MdModeEditOutline
                        className="edit-icon-enable"
                        onClick={() => { setEditHotel(true); setEditHotelSid(row) }}
                    /></span>
                </Tooltip>
                <Tooltip title="Delete" className="cursor-pointer" arrow>
                     <DeleteIcon
                        className="delete-icon-enable"
                        onClick={() => {
                            deleteHotelPopUpHandler(row);
                        }}
                    />
                </Tooltip>
            </>:
            <>
            <Tooltip title="Don't have permission to edit" arrow>
            <span>
                <MdModeEditOutline className="edit-icon-disable" />
            </span>
            </Tooltip>
            <Tooltip title="Don't have permission to delete" arrow>
            <DeleteIcon className="delete-icon-disable" />
            </Tooltip>
        </>
        );
    };
    const hotelColumns = [
        { field: "createdOn", headerName: "Date & Time", flex: 1, row: true, renderCell: (row)=> <p className="mb-0">{dayjs(row.createdOn).format("DD MMM YYYY | HH:mm")}</p> },
        { field: "displayName", headerName: "Document Name", flex: 1, row: true, renderCell: (row)=> <a
          href={row.url}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: "blue",
            textDecoration: "none",
          }}
        >
          {row.displayName}
        </a>},
        ...(userRoleCode === "ROLE_SUPER_ADMIN" 
            ? [{ field: "category", headerName: "Document Category", flex: 1, row: true, renderCell: (row)=> <p className="mb-0">{helperCategoryTable(row?.category)}</p> }] 
            : []
          ),
        {
            field: "actionCell",
            row: true,
            headerName: "Actions",
            flex: 0.5,
            renderCell: renderAPKActionIcon,
            sortDirection: false,
            disableSortIcon: true,
        },
    ];

    const uploadApkListApi = () => {
        callAPI(`/documents`, "GET")
            .then((response) => {
                const sortedResponse = response?.sort((a,b)=>a.createdOn-b.createdOn)
                setUploadApkList(sortedResponse)
            })
            .catch((err) => console.warn(err.message));
    };

    useEffect(() => {
        uploadApkListApi();
     }, []);

    useEffect(() => {
        if (editHotelSid) {
            getHotelListSidHandler();
        }
        ScrollToTop();
    }, [editHotelSid]);

    const getHotelListSidHandler = () => {
        callAPI(`/documents/${editHotelSid?.id}`, "GET")
            .then(function (response) {
                const payload = {
                    displayName: response?.displayName,
                    category: response?.category,
                    file: [{name:response?.displayName , url:response?.url}],
                };
                reset(payload);
                setEditHotelUpdate(true);
            })
            .catch(function (error) {
                console.warn(error.response?.data?.errorMessage);
            });
    }

    const cancelHotelHandler = () => {
        reset({
            displayName: '',
            category: '',
            file: [{name:"" , url:""}],
        });
        setEditHotelUpdate(false);
        setEditHotelSid('');
        setEditHotel(false);
    }

    const resetLayoutHandler = () => {
        reset();
    }
    const popupCloseHandler = () => {
        setDeleteHotelPopUp(false);
    };
    const isHotelDeletedRef = useRef({
        isHotelDeletedModalData: null,
        userConformationModalData: null,
    });

    const deleteHotelPopUpHandler = (row) => {
        setDeleteHotelPopUp(true);
        const newModalRefData = {
            isHotelDeletedModalData: {
                row
            },
            userConformationModalData: null,
        };
        isHotelDeletedRef.current = newModalRefData;
    }

    const deleteHotelHandler = () => {
        setConfirmValidate(true);
        if (confirmDeleteHotel === "") {
            return
        }
        if (confirmDeleteHotel === `Delete ${isHotelDeletedRef.current?.isHotelDeletedModalData.row.displayName}`) {
            setConfirmValidate(false)
            setLoader(true);
            const { row } = isHotelDeletedRef.current?.isHotelDeletedModalData;
            callAPI(`/documents/${row?.id}`, "DELETE")
                .then((response) => {
                    let successMessage = response.message
                    const newModalRefData = {
                        isHotelDeletedModalData: null,
                        userConformationModalData: {
                            successMessage
                        },
                    };
                    isHotelDeletedRef.current = newModalRefData;
                    uploadApkListApi();
                    setLoader(false);
                    setEditHotelSid('');
                })
                .catch((error) => {
                    console.warn(error);
                    setLoader(false);
                });
        }
        reset({
            displayName: '',
            category: '',
            file: [{name:"" , url:""}],
        });
    }

    return (
        <div className="left-column">{loader && <div className="circular-progress"><CircularProgress /></div>}
        {(userRoleCode === "ROLE_SUPER_ADMIN" && editHotel) &&
            <form autoComplete="off" onSubmit={handleSubmit(onSubmit)} className="hotel-list-form">
                <div className="row">
                    <div className="left-column-header">
                        <p>{editHotelUpdate ? 'Edit Help Manual' : 'Help Manual'}</p>
                    </div>
                    <div className="form-group-hotel col-4">
                        <div className={`floating-label`}>
                            <input
                                id="displayName"
                                maxLength={50}
                                placeholder=""
                                {...register("displayName", {
                                    required: "Please Enter Document Name",
                                    // pattern: {
                                    //     value: /^[-+]?\d+$/,
                                    //     message: "Enter valid integers",
                                    // },
                                })}
                            />
                            <label htmlFor="displayName">Enter Document Name</label>
                        </div>
                        {errors.displayName && (
                            <small className="required">{errors.displayName.message}</small>
                        )}
                    </div>
                    <div className="col-3 form-group-hotel">
                        <div className="floating-select-label">
                        <Controller
                            name="category"
                            control={control}
                            rules={{
                            validate: value => value?.length > 0 || 'Please Select Document category'
                            }}
                            render={({ field }) => (
                            <Autocomplete
                                {...field}
                                className={`multiselectlist ${field?.value && field?.value?.length > 0 ? 'Mui-focused' : ''}`}
                                limitTags={2}
                                disablePortal
                                // multiple
                                options={manualType}
                                getOptionLabel={(option) => option.toString()}
                                onChange={(_, newValue) => {
                                field.onChange(newValue);
                                }}
                                value={field.value || []}
                                renderInput={(params) => (
                                <TextField
                                    {...params}
                                    placeholder=""
                                    variant="outlined"
                                    label="Select Document category"
                                    InputLabelProps={{
                                    shrink: false,
                                    }}
                                />
                                )}
                            />
                            )}
                        />
                        </div>
                        {errors.category && (
                        <small className="required">{errors.category?.message}</small>
                        )}
                    </div>
                 <div className={`third-party-hotel-app col-5 form-group-hotel flex-item`}>
                        <div className="flex-item">
                        <Tooltip title={`Upload File`} className="cursor-pointer me-2" arrow >
                            <input
                                type="file"
                                id="file"
                                hidden="hidden"
                                // accept=".pdf"
                                {...register("file", {
                                    required: editHotelSid ? false : "Please Upload File"
                                })}
                            />
                            <label htmlFor="file" className={`${editHotelSid ? 'flex-shrink-0' : ''} p-2`}>
                                <LogoutIcon className={`me-1 rotate-270`} /> Upload File</label>
                        </Tooltip>
                        {/* <ImageResolutionTooltip style={{ color: "#913aff" }} data={iHCLAPKFile} /> */}
                        </div>
                        <span className="ms-2">{watch('file') && watch('file')[0]?.name !== "" && watch('file')[0]?.name !== undefined ? `Selected File : ${watch('file')[0]?.name}` : 'No file choosen, Yet'}</span>
                        {errors.file && <p className="required mb-0 ms-2">{errors.file.message}</p>}
                    </div>
                </div>
                <div className="col-12 form-group-hotel text-end">
                    <button type="button" className="clear-btn me-2" onClick={cancelHotelHandler}>Cancel</button>
                    {editHotelUpdate && <>
                        <button type="button" className="clear-btn me-2" onClick={resetLayoutHandler}>Reset</button>
                    </>}
                    <button type="submit" className="create-btn">{editHotelUpdate ? "Update" : "Upload"}</button>

                </div>
            </form>}
            <div className="hotel-list">
                <div className="flex-items-between mb-3">
                    <p className="mb-0"><strong>Help Manual List</strong></p>
                    {userRoleCode === "ROLE_SUPER_ADMIN"?
                        <button type="button" className={`create-btn `} onClick={() => setEditHotel(true)}>Upload File</button>
                    :<Tooltip title="Don't have permission to Upload file." arrow>
                        <span>
                        <button type="button" className={`create-btn ${validPermissionClassName}`}>Upload File</button></span>
                    </Tooltip>}
                </div>
                <TableWrapper
                    data={uploadApkList}
                    columns={hotelColumns}
                    noPagination={true}
                    module='default'
                />
            </div>
            <BasicModal
                popupOpen={createHotelSuccessMsg !== ""}
                logo={"/Images/approve-qc.png"}
                bodyMessage={<p className="mt-2">{createHotelSuccessMsg}</p>}
                footer={
                    {
                        secondaryButton: {
                            buttonName: "OK",
                            action: () => { setCreateHotelSuccessMsg(''); setEditHotelUpdate(false); },
                            buttonPrimaryCustomCss: 'cancel-btn_new'
                        }
                    }
                }
            />
            {deleteHotelPopUp && <BasicModal
                popupOpen={deleteHotelPopUp}
                bodyMessage={<>
                    <img src={deleteImg} alt="approve" className="w-40px" />
                    <div className="delete-hotel">{isHotelDeletedRef.current?.isHotelDeletedModalData ?
                        <div className="confirm-delete-hotel">
                            <p>Do you really want to Delete file " <b>{isHotelDeletedRef.current?.isHotelDeletedModalData.row.displayName}</b> " ?</p>
                            <p className="warning"><IoMdWarning /> Warning</p>
                            <p>File "{isHotelDeletedRef.current?.isHotelDeletedModalData.row.displayName}" will be permanently deleted <br />
                                Deleting the specified file can't be undone.
                            </p>
                            <p className="mt-3">To confirm deletion, type "Delete {isHotelDeletedRef.current?.isHotelDeletedModalData.row.displayName}"</p>
                            <div className="form-group-hotel mt-3">
                                <div className="floating-label">
                                    <input
                                        id="deleteHotel"
                                        placeholder=""
                                        onChange={(e) => setConfirmDeleteHotel(e.target.value)}
                                    />
                                    <label htmlFor="address">Delete {isHotelDeletedRef.current?.isHotelDeletedModalData.row.displayName}</label>
                                </div>
                                {(confirmDeleteHotel === "" && confirmValidate) ? (
                                    <small className="d-block required text-start">Please Enter Delete {isHotelDeletedRef.current?.isHotelDeletedModalData.row.displayName}</small>
                                ) : (confirmDeleteHotel !== `${isHotelDeletedRef.current?.isHotelDeletedModalData.row.displayName}` && confirmValidate) ? (
                                    <small className="d-block required text-start">Please Enter Delete {isHotelDeletedRef.current?.isHotelDeletedModalData.row.displayName}</small>
                                ) : ""
                                }
                            </div>
                        </div> :
                        isHotelDeletedRef.current?.userConformationModalData?.successMessage}</div>
                </>
                }
                footer={
                    isHotelDeletedRef.current?.isHotelDeletedModalData ?
                        {
                            primaryButton: {
                                buttonName: "Cancel",
                                action: popupCloseHandler
                            }
                            ,
                            secondaryButton: {
                                buttonName: "Delete",
                                action: deleteHotelHandler
                            }
                        } : {
                            secondaryButton: {
                                buttonName: "OK",
                                action: popupCloseHandler
                            }
                        }
                }
            />}
        </div>
    )
}
